import React from "react";
import Marquee from "react-fast-marquee";

/**
 * Rotating client logo strip. Uses typographic wordmark placeholders in
 * monochrome (gray/black) that read as real brand marks and can be swapped
 * with actual client SVG/PNG logos later.
 *
 * To swap a placeholder for a real logo, replace the { label, font, weight }
 * entry with { src: '/path-to-logo.svg', alt: 'Client name' } — the component
 * handles both shapes.
 */
const CLIENTS = [
  {
    src: "/logos/pfizer.png",
    alt: "Pfizer",
  },
  {
    src: "/logos/bank-of-america.webp",
    alt: "Bank of America",
  },
  {
    src: "/logos/merrill-lynch.png",
    alt: "Merrill Lynch — Bank of America Corporation",
  },
  {
    src: "/logos/temple-university.png",
    alt: "Temple University",
    sizeClass: "h-16 md:h-24",
  },
  {
    src: "/logos/pillar-college.png",
    alt: "Pillar College, New Jersey",
  },
  {
    src: "/logos/hirecadre.jpeg",
    alt: "Cadre",
    sizeClass: "h-16 md:h-24",
  },
  {
    src: "/logos/unknown-client.png",
    alt: "American Express Global Business Travel",
  },
  {
    src: "/logos/fore.png",
    alt: "Fore",
    sizeClass: "h-16 md:h-24",
  },
  {
    src: "/logos/magee-enterprises-color.png",
    alt: "OmniPear — Professional Development & Education Institute",
  },
  {
    src: "/logos/blacklane.jpg",
    alt: "Blacklane — Upgrade your travels",
  },
  {
    src: "/logos/mpi.png",
    alt: "Meeting Professionals International (MPI)",
  },
  {
    src: "/logos/iatan.jpg",
    alt: "Accredited by IATAN",
    sizeClass: "h-16 md:h-24",
  },
];

function ClientMark({ item }) {
  if (item.src) {
    const size = item.sizeClass || "h-12 md:h-16";
    return (
      <img
        src={item.src}
        alt={item.alt || "Client"}
        className={`${size} w-auto max-w-[240px] object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-500`}
      />
    );
  }
  return (
    <span
      className="whitespace-nowrap text-[#111827]/55 hover:text-[#0B1220] transition-colors duration-500"
      style={{
        fontFamily: item.font,
        fontWeight: item.weight,
        letterSpacing: item.tracking,
        fontStyle: item.italic ? "italic" : "normal",
        fontSize: "1.6rem",
        lineHeight: 1,
      }}
    >
      {item.label}
    </span>
  );
}

export default function ClientLogos() {
  return (
    <section
      aria-label="Trusted by clients"
      className="relative py-12 md:py-16 bg-white border-y border-[var(--border)] overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-12">
        <div className="shrink-0">
          <span className="chip">
            <span className="chip-dot" /> Trusted by
          </span>
          <p className="mt-3 font-mono-brand text-[10px] uppercase tracking-[0.24em] text-[var(--text-muted)]">
            Selected partners &amp; associations
          </p>
        </div>

        <div className="flex-1 w-full marquee-fade">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {CLIENTS.concat(CLIENTS).map((c, i) => (
              <div key={i} className="mx-10 md:mx-14 flex items-center">
                <ClientMark item={c} />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
